import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { generateUuid } from '@ftr/contracts/type/shared'
import { Uuid } from '@ftr/contracts/type/shared/Uuid'
import { ComposableDropdownModule, ComposableDropdownRenderMode, IconComponent } from '@ftr/foundation'
import { Observable } from 'rxjs'
import { CheckboxTreeItem } from '../checkbox-tree/checkbox-tree-item'
import { CheckboxTreeComponent } from '../checkbox-tree/checkbox-tree.component'

@Component({
  selector: 'ftr-checkbox-tree-dropdown',
  templateUrl: './checkbox-tree-dropdown.component.html',
  styleUrls: ['./checkbox-tree-dropdown.component.css'],
  standalone: true,
  imports: [CheckboxTreeComponent, CommonModule, ComposableDropdownModule, FormsModule, IconComponent],
})
export class CheckboxTreeDropdownComponent {
  @Input() items: Observable<CheckboxTreeItem[]>

  @Input() renderType: ComposableDropdownRenderMode = 'drop-down'

  @Input() searchPlaceholder: string = 'Search'

  // Allows us to display "Select all filtered xyzs" where xyzs might be "locations", "users", "gremlins" etc
  @Input() pluralNoun: string = ''

  @Output() childValueChange = new EventEmitter<readonly [Uuid, boolean]>()

  @ViewChild(CheckboxTreeComponent) list: CheckboxTreeComponent

  public searchInputId = generateUuid()
}
